<template>
<div class="container-fluid h-100">
    <div class="content-profile-user" id="contentProfileUser">
        <div class="row justify-content-center pr-10 pl-10">
            <h1 class="title-profile-1 text-center">GANADORES Y SUPLENTES</h1>
        </div>
        <div class="row justify-content-center">
            <div class="col-12 col-md-12 col-lg-2 col-xl-2 justify-content-center">
                <div class="btn-lottery">
                    <button
                    data-toggle="modal"
                    data-target="#modalWinner"
                    @click="getAlternate()"
                    class="btn btn-danger btn-block2"
                    >
                    <strong>¡SUPLENTE!</strong>
                    </button>
                </div>
            </div>
        </div>  
        <div class="row justify-content-center mt-2 pr-10 pl-10">
            <div v-if="data" class="col-11 col-md-8 col-lg-5 col-xl-6  mt-2">
                <h3 class="title-profile-2">GANADORES</h3>
                <template v-if="loading.history">
                    <div class="d-flex justify-content-center">
                    <div class="spinner-border text-danger" style="width: 4em; height: 4rem;" role="status"></div>
                        <strong>No hay Ganadores</strong>
                    </div>
                </template>
                <paginate v-else class="ul-pagination" name="items" :list="items" :per="10">
                    <div class="table-responsive">
                        <table class="table table-light">
                            <caption class="visually-hidden">Listado</caption>
                            <thead>
                            <tr class="table-secondary">
                                <th scope="col">No Ganador</th>
                                <th scope="col">No Documento</th>
                                <th scope="col">Nombre</th>
                                <th scope="col">Id Código</th>
                                <th scope="col">Código Redimido</th>
                            </tr>
                            </thead>
                            <tr v-for="(item, i) in paginated('items')" :key="'d' + `item-${i}`" style="text-align: initial">
                                <td style="text-align: center">{{item.id}}</td>
                                <td style="text-align: center">{{item.document_number}}</td>
                                <td style="text-align: center; text-transform:capitalize;">{{item.name.toLowerCase()}}</td>
                                <td style="text-align: center"> {{item.code_id}} </td>
                                <td style="text-align: center"> {{item.code_hidden}} </td>
                            </tr>
                        </table>
                    </div>
                </paginate>
                <div  v-if="paginationView" class="row align-items-center">
                    <div class="col-11 col-md-9 col-lg-9 col-xl-9 col-sm-12 mb-5 center-paginate ml-5" style="cursor: pointer;">
                    <paginate-links @change="pageChange" for="items" :limit="2" :show-step-links="true"
                        :step-links="{ next: '>', prev: '<' }" :classes="{ ul: 'pagination', li: 'page-item', a: 'page-link' }">
                    </paginate-links>
                    </div>
                </div>
                
            </div>
            <div v-if="data2" class="col-11 col-md-8 col-lg-5 col-xl-6  mt-2">
                <h3 class="title-profile-2">SUPLENTES</h3>
                <template v-if="loading.history">
                    <div class="d-flex justify-content-center">
                    <div class="spinner-border text-danger" style="width: 4em; height: 4rem;" role="status"></div>
                        <strong>No hay suplentes</strong>
                    </div>
                </template>
                <paginate v-else class="ul-pagination" name="items2" :list="items2" :per="10">
                    <div class="table-responsive">
                        <table class="table table-light">
                            <caption class="visually-hidden">Listado</caption>
                            <thead>
                            <tr class="table-secondary">
                                <th scope="col">No Suplente</th>
                                <th scope="col">No Documento</th>
                                <th scope="col">Nombre</th>
                                <th scope="col">Id Código</th>
                                <th scope="col">Código Redimido</th>
                            </tr>
                            </thead>
                            <tr v-for="(item, i) in paginated('items2')" :key="'d' + `item-${i}`" style="text-align: initial">
                                <td style="text-align: center">{{item.id}}</td>
                                <td style="text-align: center">{{item.document_number}}</td>
                                <td style="text-align: center; text-transform:capitalize;">{{item.name.toLowerCase()}}</td>
                                <td style="text-align: center"> {{item.code_id}} </td>
                                <td style="text-align: center"> {{item.code_hidden}} </td>
                            </tr>
                        </table>
                    </div>
                </paginate>
                <div  v-if="paginationView2" class="row align-items-center">
                    <div class="col-11 col-md-9 col-lg-9 col-xl-9 col-sm-12 mb-5 center-paginate ml-5" style="cursor: pointer;">
                    <paginate-links @change="pageChange" for="items" :limit="2" :show-step-links="true"
                        :step-links="{ next: '>', prev: '<' }" :classes="{ ul: 'pagination', li: 'page-item', a: 'page-link' }">
                    </paginate-links>
                    </div>
                </div>
                
            </div>
        </div>  
    </div>
    <!-- Modal Ganador -->
    <div class="modal fade " id="modalWinner" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content modal-question">
          <div class="modal-body">
            <button type="button" data-dismiss="modal" aria-label="Close" class="close">
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
                <div v-if="showWinner" class="row">
                    <div class="col-12 mb-1">
                        <label class="title-profile-3">  ¡SUPLENTE! </label><br />
                    </div>
                    <div class=" col-12">
                            <div class="row ">
                                <div  class="col-12 p-2">
                                    <div>
                                        <IOdometer
                                                class="iOdometer odometer odometer-auto-theme odometer-animating-up odometer-animating  odometer-ribbon-inner,  odometer odometer-theme-slot-machine odometer-animating-up odometer-animating  odometer-ribbon-inner"
                                                :value="num"
                                            />
                                    </div>
                                    <div>
                                        <label class="title-profile-3"> ¡Felicidades! </label><br />
                                    </div>
                                    <div class="mt-2">
                                    <label class="label-title2 text-center">{{alternate && alternate.name.toLowerCase()}}</label>
                                    </div>
                                    <label class="label-title2">{{alternate && alternate.document_number_hidden}}</label>
                                    <div class="mt-2">
                                    <label class="label-title3 text-center">{{alternate && 'Tu código es el finalizado en'}}</label>
                                    </div>
                                    <label class="label-title2">{{alternate && alternate.code_hidden}}</label>
                                </div>
                            </div>
                    </div>
                </div>
                <div v-else>
                    <div class="col-12 mb-3">
                        <label style="color: #616161;" class="title-profile-4">  Ya tenemos nuestros 20 Ganadores </label><br />
                    </div>
                </div>
                <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3">
                    <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-danger btn-sm btn-block button-login">
                    <template >Aceptar</template>
                    </button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Modal Ganador -->
</div>

    
</template>
<script>
import IOdometer from 'vue-odometer';
import 'odometer/themes/odometer-theme-default.css';
export default {
    components: {
      IOdometer
    },
    data() {
      return {
          loading: {
                publicate: false,
                history: false,
                changeDoc: false,
                order: false
            },
          loading2: {
                publicate: false,
                history: false,
                changeDoc: false,
                order: false
            },
          data:false,
          data2:false,
          paginationView:false,
          paginationView2:false,
          winner:null,
          alternate:null,
          paginate: ["items","items2"],
          page: 1,
          page2: 1,
          num: 123456,
          showWinner:true,
          showAlternate:true,
          timeOut:2000,
          cont:0,
      };
    },  
    methods: {
        getAlternate(){
            this.alternate = null;
            this.loading.order = true;
            this.loading.history = true;
            this.num = 0;
            let app = this;
            axios.get("coljuegos/sorteo/subtitude")
            .then((res) => {
                if (res.data.cod == 0) {
                    res.data.data.nWinner = 1;
                    console.log(res.data.data);
                this.odometro(res.data.data);
                this.loading.history = false;
                }
                this.loading.order = false;
            })
            .catch((error) => {
                this.loading.order = false;
                this.loading.history = true;
                this.$swal({
                    confirmButtonColor: "#dc3545",
                    icon: "error",
                    title: "Oops...",
                    text: error.response.data.message,
                });
            });
        },
        getAlternatesList(){
            this.items2 = [];
            this.loading.history = true;
            this.loading.order = true;
            let app = this;
            axios.get("coljuegos/sorteo/subtitudes")
            .then((res) => {
                if (res.data.cod == 0) {
                    this.items2 = res.data.data;
                    if(res.data.data.length !== 0){
                        this.data2 = true;
                        if(res.data.data.length >= 9){
                            this.paginationView2= true;
                        }
                        if(res.data.data.length === 20){
                            this.showAlternate = false;
                        }else{
                            this.showAlternate = true;
                        }   
                    }
                }
                this.loading.history = false;
                this.loading.order = false;
            })
            .catch((error) => {
                this.loading.history = false;
                this.loading.order = false;
                this.$swal({
                    confirmButtonColor: "#dc3545",
                    icon: "error",
                    title: "Oops...",
                    text: error.response.data.message,
                });
            });
        },
        getWinnersList(){
            this.items = [];
            this.loading2.history = true;
            this.loading2.order = true;
            let app = this;
            
            axios.get("coljuegos/sorteo/winners")
            .then((res) => {
                if (res.data.cod == 0) {
                    this.items = res.data.data;
                    if(res.data.data.length !== 0){
                        this.data = true;
                        if(res.data.data.length >= 9){
                            this.paginationView= true;
                        }
                        if(res.data.data.length === 20){
                            this.showWinner = false;
                        }else{
                            this.showWinner = true;
                        }   
                    }
                }
                this.loading2.history = false;
                this.loading2.order = false;
            })
            .catch((error) => {
                this.loading2.history = false;
                this.loading2.order = false;
                this.$swal({
                    confirmButtonColor: "#dc3545",
                    icon: "error",
                    title: "Oops...",
                    text: error.response.data.message,
                });
            });
        },
        
        pageChange(toPage) {
            this.page = toPage;
        },
        odometro (alternate) {
            const that = this;
            setTimeout(function () {
            that.num = alternate.code_id;
                setTimeout(function(){
                    that.alternate = alternate;
                    that.getAlternatesList();
                },1500);
            }, 500);
        },
    },
    mounted() {
        this.getAlternatesList();
        var app = this;
        var cont = 0;
        app.getWinnersList();
        setInterval(function(){
            app.getWinnersList();
        }, 10000);
    }
}
</script>

<style scoped>
@import '../../../assets/css/style.css';
@font-face {
  font-family: "ubuntu-bold";
  src: url("./../../../assets/font/Ubuntu-Bold.ttf");
  font-display: swap;
}
@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}

.content-profile-user {
  padding-top: 5%;
  padding-bottom: 5%;
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
#contentProfileUser {
  background-size: cover;
  background-image: url("../../../assets/img/03.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}
.label-title {
  font-size: 25px;
  text-align: left !important;
  margin-bottom: 0rem !important;
  color: white;
}
.label-title2 {
  text-align: center !important;
  margin-bottom: 0rem !important;
  text-transform: capitalize;
  color: #616161;
  font-size: 18px;
  font-weight: 600;
}
.label-title3 {
  text-align: center !important;
  margin-bottom: 0rem !important;
  color: #616161;
  font-size: 18px;
  font-weight: 600;
}
.title-profile-a {
  text-align: left !important;
  color: #efc700;
}
.title-profile-1 {
  font-family: "Gotham-UltraItalic", sans-serif;
  font-size: 50px;
  font-display: swap;
}
.title-profile-3 {
  font-family: "Gotham-UltraItalic", sans-serif;
  font-size: 40px;
  font-display: swap;
  color: #616161;
}
.title-profile-2 {
  font-family: "Gotham-UltraItalic", sans-serif;
  text-align: center !important;
  font-size: 30px;
  font-display: swap;
}
.title-profile-4 {
  font-family: "Gotham-UltraItalic", sans-serif;
  text-align: left !important;
  font-size: 20px;
  font-display: swap;
}
.btn-block2{
  font-size: 20px;
}
.btn-lottery {
  justify-content: center;
  align-items: center;
  align-content: center;
  margin: auto;
  margin-top: 20px;
}
b{
  font-size: 20px;  
}
.ul-pagination {
  padding: 0px;
}
.iOdometer {
  font-family: "Gotham-UltraItalic", sans-serif;
  font-size: 40px;
  margin: 0;
  color: #dc3545;
}
td {
  padding: 0.6rem !important;
}
</style>